import React, { useState } from "react"
import { FooterError } from "../../ui/errors/FooterError"
import { Loader } from "../../ui/loaders/Loader"
import { setUser, setToken } from "../../redux/authenticationSlice"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useAxios } from "../../hooks/useAxios"
import { useEnter } from "../../hooks/useEnter"

export const Login = () => {
  const api = useAxios()
  const [serviceDisabled, setServiceDisabled] = useState("")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    email: "",
    password: "",
  })
  const [errors, setErrors] = useState()

  const handleLogin = async () => {
    console.log(data)
    setErrors()
    setLoading(true)
    try {
      const response = await api.post(`${process.env.REACT_APP_BACKEND_URL}login`, data)
      console.log(response)
      dispatch(setUser(response.data.guardian))
      dispatch(setToken(response.data.guardian.token.plainTextToken))
      navigate("/dashboard")
    } catch (ex) {
      setErrors(ex.response?.data?.errors)
      if (ex?.response?.status === 555) {
        setServiceDisabled("Service disabled!")
      }
    } finally {
      setLoading(false)
    }
  }

  useEnter(handleLogin)

  return (
    <div className="position-relative container">
      <div className="w-50 card mx-auto mt-5 shadow">
        <div className="card-header fw-bold ">{process.env.REACT_APP_APP_NAME} Guardian Login</div>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type={`text`}
              className="form-control"
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type={`password`}
              className="form-control"
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
          </div>
        </div>
        <div className="card-footer d-flex align-items-center justify-content-between">
          <div>
            {loading && <Loader message={"Please wait while validating your login details.."} />}
            {errors && <FooterError error={errors?.loginDetails} />}
            {serviceDisabled != "" && (
              <div className="text-danger tw-space-x-2 tw-font-bold flex">
                <i className="fa fa-ban"></i>
                <span>{serviceDisabled}</span>
              </div>
            )}
          </div>
          <div>
            <Link to={`/forgot-password`} className="me-3">
              Forgot my password
            </Link>
            <button className="btn btn-primary" onClick={handleLogin}>
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
